/* ============================================================================
   CircleDrops — Size Guide modal controller (externalized)
   ----------------------------------------------------------------------------
   Save this file as:  assets/measurements.js
   Loaded from snippets/measurements.liquid with:
     <script src="{{ 'measurements.js' | asset_url }}" defer></script>
   (the loader sits inside the `{% if sg_number > 0 and include_modal %}` block,
   so it only loads on pages that actually render the modal.)

   This replaces the inline <script> that used to live in measurements.liquid.
   The original had NO Liquid inside it, so nothing needs to be bridged — this
   file is pure JS. It opens/closes the single #sgModalBackdrop modal and wires
   EVERY .sg-modal-trigger on the page to it (the Size Guide trigger lives in
   the Circle Size attribute card, and other measurement-snippet instances may
   add their own triggers).

   Because it is deferred, it runs after the whole document is parsed, so every
   .sg-modal-trigger already exists when it binds — strictly more reliable than
   the old inline version, which executed at its position in the page.

   An install guard (window.__cdSizeGuideModalInstalled) keeps it to a single
   initialisation even if the tag is ever emitted more than once.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__cdSizeGuideModalInstalled) return;
  window.__cdSizeGuideModalInstalled = true;

  var backdrop = document.getElementById('sgModalBackdrop');
  var closeBtn = document.getElementById('sgModalClose');
  var triggers = document.querySelectorAll('.sg-modal-trigger');
  if (!backdrop || !closeBtn || triggers.length === 0) return;

  backdrop.classList.remove('is-open');
  backdrop.removeAttribute('aria-modal');

  if (document.body && backdrop.parentNode !== document.body) {
    document.body.insertBefore(backdrop, document.body.firstChild);
  }

  var scrollPosition = 0;
  var originalPaddingRight = '';
  var lastTrigger = null;

  function getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }
  function openModal(triggerEl) {
    lastTrigger = triggerEl || null;
    scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    originalPaddingRight = document.body.style.paddingRight;
    document.documentElement.style.setProperty('--scrollbar-width', getScrollbarWidth() + 'px');
    document.documentElement.classList.add('sg-modal-open');
    document.body.classList.add('sg-modal-open');
    backdrop.classList.add('is-open');
    backdrop.setAttribute('aria-modal', 'true');
    closeBtn.focus();
  }
  function closeModal() {
    document.documentElement.classList.remove('sg-modal-open');
    document.body.classList.remove('sg-modal-open');
    document.body.style.paddingRight = originalPaddingRight;
    document.documentElement.style.removeProperty('--scrollbar-width');
    window.scrollTo(0, scrollPosition);
    backdrop.classList.remove('is-open');
    backdrop.removeAttribute('aria-modal');
    if (lastTrigger) lastTrigger.focus();
  }

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); openModal(trigger);
    });
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); openModal(trigger); }
    });
  });
  closeBtn.addEventListener('click', closeModal);
  closeBtn.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); closeModal(); }
  });
  backdrop.addEventListener('click', function (e) { if (e.target === backdrop) closeModal(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && backdrop.classList.contains('is-open')) closeModal();
  });
})();